import {
    FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_SUCCESS_DK,
    CREATE_BILL_ENTRIES_REQUEST_DK,
    CREATE_BILL_ENTRIES_SUCCESS_DK,
    CREATE_BILL_ENTRIES_FAILURE_DK,
    CREATE_USER_FORM_BILL_ENTRIES_DK,
    SET_EDIT_QUANTITY_GRID_DATA_BILL_ENTRIES_ID,
    CREATE_ADD_BILL_ENTRIES_REQUEST_DK,
    CREATE_ADD_BILL_ENTRIES_SUCCESS_DK,
    CREATE_ADD_BILL_ENTRIES_FAILURE_DK,
    CREATE_ADD_BILL_ENTRIES_DETAILS_REQUEST_DK,
    CREATE_ADD_BILL_ENTRIES_DETAILS_SUCCESS_DK,
    CREATE_ADD_BILL_ENTRIES_DETAILS_FAILURE_DK,
    FETCH_VERIFY_BILL_ENTRIES_SUCCESS_DK,
    FETCH_VERIFY_BILL_ENTRIES_REQUEST_DK,
    FETCH_VERIFY_BILL_ENTRIES_FAILURE_DK,
    FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_FAILURE_DK,
    FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_VERIFY_BILL_ENTRIES_FORM_REQUEST_DK,
    FETCH_VERIFY_BILL_ENTRIES_FORM_SUCCESS_DK,
    FETCH_VERIFY_BILL_ENTRIES_FORM_FAILURE_DK,
    NAVIGATE_VERIFY_BILL_ENTRY_DETAIL,
    FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_REQUEST_DK,
    FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_FAILURE_DK,
    FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_SUCCESS_DK,
    UPDATE_VERIFY_BILL_ENTRY_DETAILS_SUCCESS_DK,
    UPDATE_VERIFY_BILL_ENTRY_DETAILS_REQUEST_DK,
    UPDATE_VERIFY_BILL_ENTRY_DETAILS_FAILURE_DK,
    UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_SUCCESS_DK,
    UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_REQUEST_DK,
    UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_FAILURE_DK,
    CREATE_USER_FORM_VERIFY_BILL_ENTRIES_DK,
    VERIFY_BILL_ENTRY_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    VERIFY_BILL_ENTRY_USERFORM_RESET,
    NAVIGATE_BILL_ENTRIES,
    CREATE_USER_FORM_BILL_ENTRY_EDIT_QTY_DK,
    CREATE_BILL_ENTRY_APPROVAL_OTP_REQUEST,
    CREATE_BILL_ENTRY_APPROVAL_OTP_FAILURE,
    CREATE_BILL_ENTRY_APPROVAL_OTP_SUCCESS,
    UPDATE_BILL_ENTRY_DELETE_REQUEST,
    UPDATE_BILL_ENTRY_DELETE_FAILURE,
    UPDATE_BILL_ENTRY_DELETE_SUCCESS,
    CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_REQUEST,
    CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_FAILURE,
    FETCH_TALLY_FORMAT_DATA_SUCCESS_DK,
    CREATE_BILL_ENTRY_DEBIT_DETAIL_REQUEST,
    CREATE_BILL_ENTRY_DEBIT_DETAIL_SUCCESS,
    CREATE_BILL_ENTRY_DEBIT_DETAIL_FAILURE,
    FETCH_BILL_ENTRY_BRL_NUMBER_REQUEST,
    FETCH_BILL_ENTRY_BRL_NUMBER_SUCCESS,
    FETCH_BILL_ENTRY_BRL_NUMBER_FAILURE,
    DEBIT_PRINT_ID_RESET,
    CREATE_DEBIT_MEMO_DETAIL_REQUEST,
    CREATE_DEBIT_MEMO_DETAIL_SUCCESS,
    CREATE_DEBIT_MEMO_DETAIL_FAILURE,
    FETCH_DEBIT_MEMO_DATA_FAILURE,
    FETCH_DEBIT_MEMO_DATA_SUCCESS,
    FETCH_DEBIT_MEMO_DATA_REQUEST,
    SET_TABLE_EDIT_OF_DEBIT_MEMO_DATA,
    CREATE_USER_FORM_DEBIT_MEMO_ENTRIES,
    FETCH_DEBIT_MEMO_QTY_FAILURE,
    FETCH_DEBIT_MEMO_QTY_SUCCESS,
    FETCH_DEBIT_MEMO_QTY_REQUEST,
    DEBIT_MEMO_USERFORM_RESET,
    FETCH_DEBIT_MEMO_REPORT_REQUEST,
    FETCH_DEBIT_MEMO_REPORT_FAILURE,
    FETCH_DEBIT_MEMO_REPORT_SUCCESS,
    FETCH_DEBIT_MEMO_INVOICE_REQUEST,
    FETCH_DEBIT_MEMO_INVOICE_FAILURE,
    FETCH_DEBIT_MEMO_INVOICE_SUCCESS,
    DELETE_DEBIT_MRMO_REPORTS_REQUEST,
    DELETE_DEBIT_MRMO_REPORTS_FAILURE,

} from './billEntries.actionType';

export const Bill_Entries_DK = 'billEntriesDK';

let initialState = {
    loading: false,
    billEntriesInwardrid: [],
    editGridData: [],
    renderGridBtn: 'summaryGrid',
    userform: {
        fldFKSupplier: '',
        fldGrandTotalValue: 0,
        fldRoundoff: 0,
        fldDebitReason: '',
        fldFcm: true,
        fldRcm: false,
        fldTallyFormat: false
    },
    detailsId: '',
    entrydetailsId: '',
    verifyEntryData: [],
    verifyBillSelectedValue: [],
    billEntryProgramWiseData: [],
    verifyEntryFormInputData: {},
    verifyEntryTableData: [],
    verifiedentryData: {},
    verifiedentryDetailId: '',
    OtpdetailsId: '',
    isBillEntry: false,
    activeKey: 1,
    deletedetailsId: '',
    tallyFormatData: [],
    debitMemoData: [],
    debitUserform: {
        fldFKSupplier: '',
        fldInvoiceDate: new Date(),
        fldInvoiceNo: ''
    },
    debitMemoInvoice: []
};

export let billEntriesDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_REQUEST_DK:
        case CREATE_BILL_ENTRIES_REQUEST_DK:
        case CREATE_ADD_BILL_ENTRIES_REQUEST_DK:
        case CREATE_ADD_BILL_ENTRIES_DETAILS_REQUEST_DK:
        case FETCH_VERIFY_BILL_ENTRIES_REQUEST_DK:
        case FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_REQUEST_DK:
        case FETCH_VERIFY_BILL_ENTRIES_FORM_REQUEST_DK:
        case FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_REQUEST_DK:
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_REQUEST_DK:
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_REQUEST_DK:
        case CREATE_BILL_ENTRY_APPROVAL_OTP_REQUEST:
        case UPDATE_BILL_ENTRY_DELETE_REQUEST:
        case CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_REQUEST:
        case CREATE_BILL_ENTRY_DEBIT_DETAIL_REQUEST:
        case FETCH_BILL_ENTRY_BRL_NUMBER_REQUEST:
        case CREATE_DEBIT_MEMO_DETAIL_REQUEST:
        case FETCH_DEBIT_MEMO_DATA_REQUEST:
        case FETCH_DEBIT_MEMO_QTY_REQUEST:
        case FETCH_DEBIT_MEMO_REPORT_REQUEST:
        case FETCH_DEBIT_MEMO_INVOICE_REQUEST:
        case DELETE_DEBIT_MRMO_REPORTS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                billEntriesInwardrid: updatePayload?.BED,
                // editGridData: updatePayload?.BED

                editGridData:
                    updatePayload?.BED && updatePayload?.BED.map((x) => ({ ...x, FldRatePerKG: x?.FldRatePerKG.toFixed(4) }))

            };
        case FETCH_VERIFY_BILL_ENTRIES_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                verifyEntryData: updatePayload?.BED
            };
        case FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                billEntryProgramWiseData: updatePayload?.BED
            };
        // case CREATE_BILL_ENTRIES_SUCCESS_DK:
        //     return {
        //         ...state,
        //         loading: false,
        //         userform: {
        //             fldFKSupplier: '',
        //             fldGrandTotalValue: 0,
        //             fldRoundoff: 0
        //         },
        //         detailsId: updatePayload
        //     };
        case CREATE_USER_FORM_BILL_ENTRIES_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_DEBIT_MEMO_ENTRIES:
            return {
                ...state,
                loading: false,
                debitUserform: {
                    ...state.debitUserform,
                    [payload.key]: payload.value
                }
            };

        case CREATE_USER_FORM_VERIFY_BILL_ENTRIES_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };

        case CREATE_ADD_BILL_ENTRIES_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKSupplier: '',
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case CREATE_DEBIT_MEMO_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                debitdetailsId: updatePayload,
            };
        case CREATE_ADD_BILL_ENTRIES_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKSupplier: '',
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                entrydetailsId: updatePayload
            };
        case FETCH_VERIFY_BILL_ENTRIES_FORM_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                verifyEntryFormInputData: updatePayload
            };
        case FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                verifyEntryTableData: updatePayload
            };
        case FETCH_TALLY_FORMAT_DATA_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                tallyFormatData: updatePayload?.BED
            }
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                verifiedentryData: updatePayload
            }
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                verifiedentryDetailId: updatePayload
            }
        case VERIFY_BILL_ENTRY_USERFORM_RESET:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKSupplier: '',
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldInvIGST: 0,
                    fldInvSGST: 0,
                    fldInvCGST: 0,
                    fldInvGSTTotal: 0,
                    fldOtherValue: 0,
                    fldOtherIGST: 0,
                    fldOtherSGST: 0,
                    fldOtherCGST: 0,
                    fldOtherGSTTotal: 0,
                    fldNetTotalValue: 0,
                    fldDebitValue: 0,
                    fldFcm: true,
                    fldRcm: false,

                },
                detailsId: '',
                deletedetailsId: '',
                editGridData: [],
                verifyEntryFormInputData: [],
                verifyEntryTableData: [],
                brlNo: '',
                //debitQty: ''
            }
        case DEBIT_MEMO_USERFORM_RESET:
            return {
                ...state,
                loading: false,
                debitUserform: {
                    fldFKSupplier: '',
                    fldInvoiceDate: new Date(),
                    fldInvoiceNo: '',
                },
                brlNo: '',
            }
        case VERIFY_BILL_ENTRY_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                loading: false,
                verifyEntryFormInputData: {
                    fldProgramName: ' ',
                    fldSupplierName: ' ',
                    fldBENo: ' ',
                    fldApprovedByName: ' ',
                    fldApprovedDate: ' ',
                    fldInvoiceNo: '',
                    fldInvoiceValue: 0,
                    fldOtherValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    fldInvIGST: 0,
                    fldInvSGST: 0,
                    fldInvCGST: 0,
                    fldInvGSTTotal: 0,
                    fldOtherIGST: 0,
                    fldOtherSGST: 0,
                    fldOtherCGST: 0,
                    fldOtherGSTTotal: 0,
                    fldRoundoff: 0,
                    fldNetTotalValue: 0,
                    fldDebitValue: 0,
                    fldDebitReason: 0,
                    fldDebitNoteNo: '',
                    fldTDSPercentage: 0,
                    fldTDSAmt: 0,
                    fldTDSRoundOff: 0,
                    fldTCSPercentage: 0,
                    fldTCSAmt: 0,
                    fldTCSRoundOff: 0,
                    fldTDSTCSDedAmt: 0,
                    fldGrandTotalValue: 0
                },
                verifyEntryTableData: [],
                // verifiedentryDetailId:'',
                // activekey: 1
            }
        case CREATE_USER_FORM_BILL_ENTRY_EDIT_QTY_DK:
            return {
                ...state,
                loading: false,
                // userform: {
                //     ...state.userform
                // },
                editGridData: payload
            };
        case CREATE_BILL_ENTRY_APPROVAL_OTP_SUCCESS:
            return {
                ...state,
                loading: false,
                OtpdetailsId: updatePayload
            };
        case UPDATE_BILL_ENTRY_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                deletedetailsId: updatePayload
            };
        case CREATE_BILL_ENTRY_DEBIT_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                debitdetail: updatePayload
            };
        case FETCH_BILL_ENTRY_BRL_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                brlNo: updatePayload
            };
        case FETCH_DEBIT_MEMO_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                debitMemoData: updatePayload?.BED
            };
        case FETCH_DEBIT_MEMO_QTY_SUCCESS:
            return {
                ...state,
                loading: false,
                debitQty: updatePayload
            };
        case FETCH_DEBIT_MEMO_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                debitMemoReport: updatePayload
            };
        case FETCH_DEBIT_MEMO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                debitMemoInvoice: updatePayload
            };
        case FETCH_SINGLE_DATA_FOR_BILL_ENTRIES_FAILURE_DK:
        case CREATE_BILL_ENTRIES_FAILURE_DK:
        case CREATE_ADD_BILL_ENTRIES_FAILURE_DK:
        case CREATE_ADD_BILL_ENTRIES_DETAILS_FAILURE_DK:
        case FETCH_VERIFY_BILL_ENTRIES_FAILURE_DK:
        case FETCH_BILL_ENTRY_PROGRAM_WISE_DATA_FOR_REPORT_FAILURE_DK:
        case FETCH_VERIFY_BILL_ENTRIES_TABLE_DATA_FAILURE_DK:
        case FETCH_VERIFY_BILL_ENTRIES_FORM_FAILURE_DK:
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_FAILURE_DK:
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_FAILURE_DK:
        case CREATE_BILL_ENTRY_APPROVAL_OTP_FAILURE:
        case UPDATE_BILL_ENTRY_DELETE_FAILURE:
        case CREATE_BILL_ENTRY_WITH_DEBIT_OR_CREDIT_NOTE_FAILURE:
        case CREATE_BILL_ENTRY_DEBIT_DETAIL_FAILURE:
        case CREATE_DEBIT_MEMO_DETAIL_FAILURE:
        case FETCH_DEBIT_MEMO_DATA_FAILURE:
        case FETCH_DEBIT_MEMO_QTY_FAILURE:
        case FETCH_DEBIT_MEMO_INVOICE_FAILURE:
        case FETCH_DEBIT_MEMO_REPORT_FAILURE:
        case DELETE_DEBIT_MRMO_REPORTS_FAILURE:
            return {
                ...state,
                loading: false,
                debitQty: updatePayload
            };
        case SET_EDIT_QUANTITY_GRID_DATA_BILL_ENTRIES_ID:
            return {
                ...state,
                loading: false,
                editGridData: payload
            };

        case NAVIGATE_VERIFY_BILL_ENTRY_DETAIL:
            return {
                ...state,
                isYarnPO: true,
                loading: false,
                yarnPOSelectedValue: updatePayload.yarnPOSelectedValue
            };
        case FETCH_BILL_ENTRY_BRL_NUMBER_FAILURE:
            return {
                ...state,
                loading: false,
                brlNo: updatePayload
            };
        case NAVIGATE_BILL_ENTRIES:
            return {
                ...state,
                isBillEntry: false
            };
        default:
            return state;
    }
};
